import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Question from '../../entities/question';
import Answer from '../../entities/answer';
export function deleteQuestion(question: Question, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = question.id;}
const _work = workingSet();
store.getState().answers.getMappingFor('questionId', question.id).filter(answerTemp => answerTemp.status !== 'D').forEach(answerTemp => {
const _answer = ((_work.get('answer:' + answerTemp.id) ?? answerTemp) as Answer).clone();
_answer.status = 'U';
_answer.addedOn = newHRTimestamp();
_answer.addedBy = getCurrentUserId();
_answer.importSource = targetImportSource;
_answer.importId = mergeId;
if (_answer.questionId === question.id) {
_answer.questionId = '';

}
_work.set('answer:' + _answer.id, _answer);
store.dispatch(Actions.AnswerActions.saveAnswerQueue(_answer));
});



question.status = 'D';
question.addedOn = newHRTimestamp();
question.addedBy = getCurrentUserId();
question.importSource = targetImportSource;
question.importId = mergeId;
store.dispatch(Actions.QuestionActions.removeQuestionQueue(question));
}
export function replaceQuestion(question: Question, replaceWith: Question, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = question.id;}
const _work = workingSet();
store.getState().answers.getMappingFor('questionId', question.id).filter(answerTemp => answerTemp.status !== 'D').forEach(answerTemp => {
const _answer = ((_work.get('answer:' + answerTemp.id) ?? answerTemp) as Answer).clone();
_answer.status = 'U';
_answer.addedOn = newHRTimestamp();
_answer.addedBy = getCurrentUserId();
_answer.importSource = targetImportSource;
_answer.importId = mergeId;
if (_answer.questionId === question.id) {
_answer.questionId = replaceWith.id;

}
_work.set('answer:' + _answer.id, _answer);
store.dispatch(Actions.AnswerActions.saveAnswerQueue(_answer));
});



return question;
}
export function deleteImpactQuestion(question: Question) {
const impacts: string[] = [];
const state = store.getState();
const answerQuestionIdImpact = state.answers.getMappingFor('questionId', question.id).filter(answer => answer.status !== 'D');
answerQuestionIdImpact.forEach(() => impacts.push('answers*'));



return util.countDistinct(impacts);
}
